import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Alert, Snackbar, Dialog, DialogActions, DialogContent, DialogContentText, TextField, DialogTitle, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import UtilsFormule from "../utils/UtilsFormule";


const DataTableTicketPayement = ({ payementTickets }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const secret="SECRET123"
  // const [payementTickets, setpayementTickets] = useState(availableTicket);
  // const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const { SearchBar } = Search;

  function PriceFormatter(cell, row) {
    if (cell != null && cell != "") {
      return <span>{cell} TND</span>;
    } else {
      return <span>-</span>;
    }
  }

  function DateFormatter(cell, row) {
    if (cell != null && cell != "") {
      return UtilsFormule.formatDateHours(cell);
    } else {
      return <span>-</span>;
    }
  }

  function typePayementFormatter(cell, row) {
    switch (cell) {
      case "accept":
        return "Accepté";
      case "refuse":
        return "Rejeté";
      case "refuse-def":
        return "Refusé définitivement";
      case "none":
        return "non rapproché";
      default:
        return "-";
    }
  }

    const onViewEchangePayementHandler = (row) => {
    sessionStorage.setItem("idPayementEchange", row?.id);
    sessionStorage.setItem("refPayementEchange", referenceFormatter("",row));
    sessionStorage.setItem("typePayementEchange", row?.typePayement);

    sessionStorage.setItem("amountPayementEchange", row?.amountPayed);
    const pdfWindow = window.open();
    pdfWindow.location.href = "/echangePaiementTicket";
    // navigate("/getDocumentSalesByRef");
  };
  function buttonDeleteFormatter(cell, row) {
    return (
      <span>
        <button
          className="btn btn-dark"
          onClick={() => onViewEchangePayementHandler(row)}
        >
          <h6>
            <small>
             <i class="fas fa-rotate"></i>
            </small>
          </h6>
        </button>
      </span>
    );
  }
  function referenceFormatter(cell, row) {
    switch (row?.typePayement) {
      case "Espéce":
        return row.ref + "-" + row.year;
      case "En ligne":
        return row.ref;
      case "Chéque / Traites":
        return row.codeCheque;
      case "Virement":
        return row.numVirement;
      case "CarteCadeau":
        return row.ref + "-" + row.year;
      case "RSS":
        return row.reference ;
      default:
        return null;
    }
  }
  
  const columns = [
    {
      dataField: "reference",
      text: "#Référence",
      align: "center",
      headerAlign: "center",
      formatter: referenceFormatter,
    },
    {
      dataField: "typePayement",
      text: "Type",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "creationDate",
      text: "DC",
      align: "center",
      headerAlign: "center",
      formatter: DateFormatter,
      headerStyle: () => {
        return { width: "20%" };
      },
    },

    {
      dataField: "typePayementValidation",
      text: "Operation",
      align: "center",
      formatter: typePayementFormatter,
      headerAlign: "center",
    },
    {
      dataField: "operationDate",
      text: "DO",
      align: "center",
      formatter: DateFormatter,
      headerAlign: "center",
    },
    {
      dataField: "amountPayed",
      text: "M.Payé",
      align: "center",
      formatter: PriceFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "id",
      text: "Actions",
      formatter: buttonDeleteFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
  ];

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ payementTickets }) {
    return payementTickets;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Paiement</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={payementTickets}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                  <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
      {/* <Dialog
              open={openDeleteModal}
              onClose={handleCloseDeleteModal}
              aria-labelledby="delete-dialog-title"
              aria-describedby="delete-dialog-description"
            >
              <DialogTitle id="delete-dialog-title">Confirmer la Suppression</DialogTitle>
              <DialogContent>
                <DialogContentText id="delete-dialog-description">
                  Veuillez écrire la référence <strong>{reference}</strong> ci-dessous pour confirmer la suppression. Cette action est irréversible.
                </DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  id="reference-input"
                  label="Entrez la Référence"
                  type="text"
                  fullWidth
                  value={enteredReference}
                  onChange={(e) => setEnteredReference(e.target.value)}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseDeleteModal} color="secondary">
                  Annuler
                </Button>
                <Button
                  onClick={handleDelete}
                  color="primary"
                  disabled={enteredReference !== reference}
                >
                  Confirmer & Supprimer
                </Button>
              </DialogActions>
            </Dialog> */}
    </div>
  );
};
export default DataTableTicketPayement;
